import {users as usersShared} from '@cl/shared';
import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import createCampaignFromExcelTool from './excelImport/createCampaignFromExcelTool';
import findMappingCandidatesTool from './excelImport/findMappingCandidatesTool/findMappingCandidatesTool';
import getCampaignSignalsTool from './excelImport/getCampaignSignalsTool';
import sanitizeValuesTool from './excelImport/sanitizeValuesTool/sanitizeValuesTool';
import showExcelImportSummaryTool from './excelImport/showExcelImportSummaryTool';
import validateMappingsTool from './excelImport/validateMappingsTool/validateMappingsTool';
import {reloadCampaign} from './utils/reloadCampaign';
import placementsManagementTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/placementsManagementTool/placementsManagementTool';
import addOrUpdateDistributionCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/distribution/addOrUpdateDistributionCardToolV2';
import addOrUpdateSequenceCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/sequence/addOrUpdateSequenceCardToolV2';
import listSelectionStrategiesTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/strategy/listSelectionStrategiesTool';
import getSelectionStrategyDetailsTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgent/tools/strategy/getSelectionStrategyDetailsTool';
import addOrUpdateCompoundConditionCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/compoundConditions/addOrUpdateCompoundConditionCardToolV2';
import addOrUpdateConditionCardToolNG from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/conditions/addOrUpdateConditionCardToolV2';
import addOrUpdateContentCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/content/addOrUpdateContentCardToolV2';
import addOrUpdateCreativeCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/creative/addOrUpdateCreativeCardToolV2';
import {getCardDetailsFromReduxTool} from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/general/getCardDetailsFromReduxTool';
import addOrUpdateLocationCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/location/addOrUpdateLocationCardToolV2';
import addOrUpdateOptimizationCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/optimization/addOrUpdateOptimizationCardToolV2';
import addOrUpdateProductCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/product/addOrUpdateProductCardToolV2';
import addOrUpdateScheduleCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/schedule/addOrUpdateScheduleCardToolV2';
import addOrUpdateWeightedCardToolV2 from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/standaloneAgents/promptToCardAgentV2/tools/weighted/addOrUpdateWeightedCardToolV2';
import askAboutObjectsTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/askAboutObjectsTool/askAboutObjectsTool';
import cardsConnectionTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/cardsConnectionTool/cardsConnectionTool';
import deleteCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/deleteCardTool/deleteCardTool';
import duplicateCardTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/duplicateCardTool/duplicateCardTool';
import duplicateSubtreeTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/duplicateSubtreeTool/duplicateSubtreeTool';
import readValuesFromExcelTool from 'common/src/modules/shared/copilot/tools/readValuesFromExcelTool/readValuesFromExcelTool';
import verifyCampaignPathTool from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/tools/general/verifyCampaignPathTool/verifyCampaignPathTool';
import {CampaignsAgentsToolsNames} from 'common/src/modules/campaigns/copilot/copilotCampaigns.enums';
import createCampaignTool from 'common/src/modules/campaigns/copilot/tools/createCampaignTool';
import duplicateCampaignTool from 'common/src/modules/campaigns/copilot/tools/duplicateCampaignTool';
import getCampaignsMetadataTool from 'common/src/modules/campaigns/copilot/tools/getCampaignsMetadataTool';
import navigateToCampaignVersionTool from 'common/src/modules/campaigns/copilot/tools/navigateToCampaignVersionTool';
import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import {EntityTypeToRename} from 'common/src/modules/shared/copilot/copilot.enums';
import analyzeExcelHeadersTool from 'common/src/modules/shared/copilot/tools/analyzeExcelHeadersTool/analyzeExcelHeadersTool';
import batchRenameEntitiesTool from 'common/src/modules/shared/copilot/tools/batchRenameEntitiesTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';
import campaignSetupSkillInstructions from './campaignSetupSkill.instructions';
import {setShouldAutoArrange} from '../../../store/campaignLogicTab/campaignLogic.slice';

function campaignSetupSkill(store: CLStore) {
  const userHasCampaignsWriteRole = doesUserHaveRole(
    usersShared.userSubject.data,
    RoleTypeName.CampaignsWrite,
  );

  const permissionsRelatedTools = userHasCampaignsWriteRole
    ? [
        createCampaignTool({isAllowingSocialCampaigns: true, store}),
        duplicateCampaignTool({store}),
        batchRenameEntitiesTool({
          entityType: EntityTypeToRename.Campaign,
          toolName: CampaignsAgentsToolsNames.BatchRenameCampaigns,
        }),
        createCampaignFromExcelTool(() =>
          reloadCampaign(store).then(() => {
            store.dispatch(setShouldAutoArrange(true));
          }),
        ),
      ]
    : [];

  const tools = [
    ...permissionsRelatedTools,
    navigateToCampaignVersionTool(store),
    // navigateToCampaignsLibraryTool(store),
    getCampaignsMetadataTool(store),

    addOrUpdateWeightedCardToolV2(store),
    addOrUpdateDistributionCardToolV2(store),
    addOrUpdateOptimizationCardToolV2(store),
    addOrUpdateCreativeCardToolV2(store),
    addOrUpdateScheduleCardToolV2(store),
    addOrUpdateConditionCardToolNG(store),
    addOrUpdateCompoundConditionCardToolV2(store),
    addOrUpdateSequenceCardToolV2(store),
    addOrUpdateContentCardToolV2(store),
    addOrUpdateLocationCardToolV2(store),
    addOrUpdateProductCardToolV2(store),
    deleteCardTool(store),
    duplicateSubtreeTool(store),
    duplicateCardTool(store),
    getCardDetailsFromReduxTool(store),
    cardsConnectionTool(store),
    listSelectionStrategiesTool(store),
    getSelectionStrategyDetailsTool(store),
    askAboutObjectsTool(store),

    getFilesTool(),
    analyzeExcelHeadersTool(),
    readValuesFromExcelTool(),
    getCampaignSignalsTool(),
    findMappingCandidatesTool(),
    validateMappingsTool(),
    sanitizeValuesTool(),
    showExcelImportSummaryTool(),
    verifyCampaignPathTool(CampaignStep.CampaignLogic, store),
    placementsManagementTool(store),
  ];

  return skill({
    name: SkillName.CampaignSetup,
    description:
      'Helps users create, configure, and manage campaign decision trees with cards, logic, and behavior',
    whenToUse:
      'Creating new campaigns, duplicating campaigns, and batch renaming campaigns. Campaign logic and behavior setup including building and editing decision trees with cards. Supports all card types: weighted, optimization, condition, schedule, creative, product, location, content, sequence, and distribution cards. Can add, edit, delete, connect, and duplicate cards, manage fallback creatives, configure placements. Can also answer questions about existing campaigns and their card configurations using metadata and Excel data.',
    whenToAvoid: 'Campaign analytics, performance metrics, or social campaign configuration.',
    instructions: campaignSetupSkillInstructions,
    tools,
    knowledgeTopics: [KnowledgeRagTopic.CampaignSetupAgent, KnowledgeRagTopic.ExcelCampaignImport],
    applicableBreadcrumbs: [
      BreadcrumbName.CampaignPage,
      BreadcrumbName.CampaignLogic,
      BreadcrumbName.CampaignsLibrary,
    ],
  });
}

export default campaignSetupSkill;
